import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Field, ModeFieldDate, TypeField } from '@ascschool/interface/form/field';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'dynamic-form-expand',
  templateUrl: './dynamic-form-expand.component.html',
  styleUrls: ['./dynamic-form-expand.component.scss']
})
export class DynamicFormExpandComponent implements OnInit {
  @Output() onSearch = new EventEmitter();
  @Output() onCollape = new EventEmitter();
  @Output() onChangeValue = new EventEmitter();
  @Input() eventsFromButton : Observable<void>;
  @Input() fields: Field[] = [];
  @Input() isClearBtn: boolean;
  @Input() isCollapseBtn: boolean;
  @Input() collapseBtn: boolean;
  @Input() numberCollapse: number;
  @Input() value: any;
  divisibleForFour: boolean;
  isCollapse_t = true;
  type = TypeField;
  form: FormGroup;
  constructor() { }

  ngOnInit() {
    this.setForm(this.fields);
    this.divisibleForFour = this.isDivisibleForFour(this.numberCollapse);
    this.formChangeValue();
  }
  setForm(fields: Field[]){
    let fieldsCtrls = {};
    for (let f of fields) {
      fieldsCtrls[f.controlName] = new FormControl(f.value || '', f.required === true ?  Validators.required : null);
      if(f.validatorCustom){
        let validator = [];
        f.validatorCustom.forEach(vld =>{
          validator.push(vld.validator);
        })
        fieldsCtrls[f.controlName] = new FormControl(f.value || '', validator.length >0 ?  validator : null);
      }
    }
    this.form = new FormGroup(fieldsCtrls);
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  submit(){
    let value = {};
    let formValue = this.form.value;
    for (const i of this.fields) {
      this.form.controls[i.controlName].markAsDirty();
      this.form.controls[i.controlName].updateValueAndValidity();
      if(formValue[i.controlName] !== null && formValue[i.controlName] !== undefined && formValue[i.controlName] !== ''){
        if(i.type === TypeField.SELECT_AUTOCOMPLETE){
          value[i.controlName] = formValue[i.controlName].id;
        }else if(i.type === TypeField.DATETIME){
          if(i.nzMode === ModeFieldDate.WEEK){
            value[i.controlName] = formValue[i.controlName].getWeek();
          }else if(i.nzMode === ModeFieldDate.YEAR){
              value[i.controlName] = formValue[i.controlName].getFullYear();
          }else if(i.nzMode === ModeFieldDate.MONTH){
            value[i.controlName] = formValue[i.controlName].getMonth();
          }else if(i.nzMode === ModeFieldDate.DATE){
            let dd = String(formValue[i.controlName].getDate()).padStart(2, '0');
            let mm = String(formValue[i.controlName].getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = formValue[i.controlName].getFullYear();
            value[i.controlName] = mm + '/' + dd + '/' + yyyy;
          }
        }else{
          value[i.controlName] = formValue[i.controlName];
        }
      }else if(typeof formValue[i.controlName] === 'number'){
        value[i.controlName] = formValue[i.controlName];
      }
      if(formValue[i.controlName] === false){
        value[i.controlName] = formValue[i.controlName];
      }
    }
    return value;
  }
  search(){
    if(this.form.valid){
      this.onSearch.emit(this.submit());
    }
  }
  toggleCollapse(): void {
    this.isCollapse_t = !this.isCollapse_t;
    if(this.isCollapse_t){
      this.divisibleForFour = this.isDivisibleForFour(this.numberCollapse);
    }else{
      this.divisibleForFour = this.isDivisibleForFour(this.fields.length);
    }
    this.onCollape.emit(this.isCollapse_t);
  }
  clear(){

    this.form.reset();
    this.search();
  }
  changeSelected(event){
    const nameControl = this.getName(event);
    this.fields.forEach((field)=>{
      if(field.controlName === nameControl && field.handlerSelected){
        field.handlerSelected(event.value);
      }
    });
  }
  getName(control: AbstractControl): string | null {
    let group = <FormGroup>control.parent;
    if (!group) {
      return null;
    }
    let name: string;
    Object.keys(group.controls).forEach(key => {
      let childControl = group.get(key);
      if (childControl !== control) {
        return;
      }
      name = key;
    });
    return name;
  }
  formChangeValue(){
    this.form.valueChanges.subscribe(x => {
      this.onChangeValue.emit(this.form.value);
    });
  }

}
